import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsPersonPhotoSelectedInfo, wsPersonPhotoSelectedInfoWithOptions } from "./wsPersonPhotoSelectedInfo";
import { wsPersonPhotoUploadInfo } from "./wsPersonPhotoUploadInfo";
import { wsPersonPhotoEditInfo } from "./wsPersonPhotoEditInfo";
import { wsPersonPhotoEditUploadInfo } from "./wsPersonPhotoEditUploadInfo";
import { wsPhotoAIUploadInfo } from "./wsPhotoAIUploadInfo";
import { wsAiColorPickerParmInfo, wsAiColorPickerInfo } from "./wsPhotoAIColorPresetInfo";

import { PhotoInfo } from "./PhotoInfo";
import { wsImageStagingQueueFilterListRequest } from "./wsImageStagingQueueFilterListInfo";

@Injectable()
export class DataService_photomaint {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	getData
	//
	//-----------------------------------------------------------------------------------------------------
	getData() {
		var postResult$ = new Subject();
		var url = "PhotoID/GetData";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageStagingQueueSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	ImageStagingQueueSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageStagingQueueSelectList";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageStagingQueueAssign
	//
	//-----------------------------------------------------------------------------------------------------
	ImageStagingQueueAssign(selected: wsPersonPhotoSelectedInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageStagingQueueAssign";

		var promise$ = this.httpclientService.post(url, selected);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageStagingQueueUnassign
	//
	//-----------------------------------------------------------------------------------------------------
	ImageStagingQueueUnassign(selected: wsPersonPhotoSelectedInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageStagingQueueUnassign";

		var promise$ = this.httpclientService.post(url, selected);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageStagingQueueManualAssign
	//
	//-----------------------------------------------------------------------------------------------------
	ImageStagingQueueManualAssign(selected: wsPersonPhotoSelectedInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageStagingQueueManualAssign";

		var promise$ = this.httpclientService.post(url, selected);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageStagingQueueDelete
	//
	//-----------------------------------------------------------------------------------------------------
	ImageStagingQueueDelete(selected: wsPersonPhotoSelectedInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageStagingQueueDelete";

		var promise$ = this.httpclientService.post(url, selected);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageStagingQueueTransfer
	//
	//-----------------------------------------------------------------------------------------------------
	ImageStagingQueueTransfer(selected: wsPersonPhotoSelectedInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageStagingQueueTransfer";

		var promise$ = this.httpclientService.post(url, selected);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageStagingQueueTransferAddToQ
	//
	//-----------------------------------------------------------------------------------------------------
	ImageStagingQueueTransferAddToQ(selected: wsPersonPhotoSelectedInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageStagingQueueTransferAddToQ";

		var promise$ = this.httpclientService.post(url, selected);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageStagingQueueFilterListSelect
	//
	//-----------------------------------------------------------------------------------------------------
	ImageStagingQueueFilterListSelect(parms: wsImageStagingQueueFilterListRequest) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageStagingQueueFilterListSelect";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageStagingQueueTransferWithOptions
	//
	//-----------------------------------------------------------------------------------------------------
	ImageStagingQueueTransferWithOptions(selected: wsPersonPhotoSelectedInfoWithOptions) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageStagingQueueTransferWithOptions";

		var promise$ = this.httpclientService.post(url, selected);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageStagingQueueUpload
	//
	//-----------------------------------------------------------------------------------------------------
	ImageStagingQueueUpload(SchoolID: number, Myimage: PhotoInfo) {
		let obj: wsPersonPhotoUploadInfo = {
			SchoolID: SchoolID,
			idx: 0,
			PhotoName: Myimage.PhotoName,
			PhotoDateTime: Myimage.PhotoDateTime,
			PhotoUrl: Myimage.PhotoUrl,
		};

		var postResult$ = new Subject();
		var url = "PhotoID/UploadPhotos";

		var promise$ = this.httpclientService.post(url, obj);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PersonPhotoEditGet
	//
	//-----------------------------------------------------------------------------------------------------
	PersonPhotoEditGet(parm: wsPersonPhotoEditInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/PersonPhotoEditGet";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PersonPhotoEditUpload
	//
	//-----------------------------------------------------------------------------------------------------
	PersonPhotoEditUpload(Myimage: wsPersonPhotoEditUploadInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/PersonPhotoEditUpdate";

		var promise$ = this.httpclientService.post(url, Myimage);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoAIRemoveBackground
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoAIRemoveBackground(parm: wsPhotoAIUploadInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoAIRemoveBackground";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoAICreatePortrait
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoAICreatePortrait(parm: wsPhotoAIUploadInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoAICreatePortrait";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}	

	//-----------------------------------------------------------------------------------------------------
	//
	//	AIColorPickerGet
	//
	//-----------------------------------------------------------------------------------------------------
	AIColorPickerGet(parm: wsAiColorPickerParmInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/AIColorPickerGet";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AIColorPickerUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	AIColorPickerUpdate(parm: wsAiColorPickerInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/AIColorPickerUpdate";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}		
}
